// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._8mwv5l0 {
  width: 100%;
}
@media screen and (min-width:768px) {
  ._8mwv5l0 {
    width: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["._8mwv5l0 {\n  width: 100%;\n}\n@media screen and (min-width:768px) {\n  ._8mwv5l0 {\n    width: 260px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
